
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "WHO_UMC",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/WHO_UMC.vue